import { render } from "./logo-stacked.svg?vue&type=template&id=789bf660"
const script = {}

import exportComponent from "/Users/danilomeulens/Projects/_sandbox/simpsonbay_geneology/source/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__